import { Button, Form, Modal, TextArea } from '@mairistem/composants';
import React from 'react';
import useModalSuperUserValidation from '../../../../../hooks/useModalSuperUserValidation';
import type { BordereauWithState } from '../../../../../interfaces/pieces/TreeRow';

interface BordereauMettreEnEchecModalProps {
	onChange: (data: BordereauWithState) => void;
	onClose: VoidFunction;
	visible: boolean;
	isSuperUser: boolean;
	bordereau: BordereauWithState;
}

const BordereauMettreEnEchecModal = ({
	onClose,
	onChange,
	visible,
	isSuperUser,
	bordereau,
}: BordereauMettreEnEchecModalProps) => {
	const [motifEchec, setMotifEchec] = React.useState<string>('');

	const handleClick = (): void => {
		onChange({
			...bordereau,
			motifEchec,
		});
		onClose();
	};

	const handleChangeMotif = (_e: any, { value }: any): void => {
		setMotifEchec(value);
	};

	const { isValidated, validationComponent } = useModalSuperUserValidation();

	return (
		<Modal
			closeIcon
			open={visible}
			onClose={onClose}
			data-testid="bordereauMettreEnEchecModal"
		>
			<Modal.Header>
				Mettre en échec le bordereau n°
				{bordereau.numero} suite à un incident technique
			</Modal.Header>
			<Modal.Content>
				<p>
					{`Cette action vous permet de forcer le statut du bordereau en connaissance de la perte ou de l’impossibilité
        d’exploiter le dernier flux PES émis. Vous pourrez alors retraiter le bordereau (réémission, rejet selon le contexte).`}
				</p>
				<Form>
					<Form.Field
						key="motifEchec"
						name="motifEchec"
						value={motifEchec}
						onChange={handleChangeMotif}
						control={TextArea}
						data-testid="borderauMettreEnEchecMotif"
						label="Motif de l'échec"
						placeholder="Vous devez renseigner un motif pour justifier l'échec du bordereau"
						required
						rows={2}
					/>
				</Form>
				{isSuperUser && validationComponent}
			</Modal.Content>
			<Modal.Actions>
				<Button
					onClick={onClose}
					data-testid="bordereauMettreEnEchecModalCancel"
				>
					Annuler
				</Button>
				<Button
					primary
					onClick={handleClick}
					disabled={(isSuperUser && !isValidated) || !motifEchec}
					data-testid="bordereauMettreEnEchecModalConfirm"
				>
					Confirmer
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default BordereauMettreEnEchecModal;
